<template>
    <form name="form-speaker" id="form-speaker" @submit="onSubmit">

        <div class="form-row">

            <div class="col-md">

                <div class="form-group">
                    <label for="companyName">Company Name</label>
                    <p class="form-control">{{ speaker.companyName }}</p>
                </div>

                <div class="form-group">
                    <label for="currentPosition">Current Position</label>
                    <p class="form-control">{{ speaker.currentPosition }}</p>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <p class="form-control">{{ speaker.email }}</p>
                </div>

                <div class="form-group">
                    <label for="phoneNumber">Phone Number</label>
                    <p class="form-control">{{ speaker.phoneNumber }}</p>
                </div>

                <div class="form-group">
                    <label for="biography">Biography</label>
                    <p class="text-justify">{{ speaker.biography }}</p>
                </div>
            </div>

        </div>
    </form>
</template>

<script>

import {defineComponent} from 'vue'
import moment from "moment";

export default defineComponent({
    name: 'SpeakerCardView',
    components: {
        
    },
    props: {
        speaker: {
            type: Object,
            required: true
        }
    },
    methods: {
        fmtDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        fmtTime(date) {
            return moment(date).format("HH:mm");
        },
    }
})
</script>

<style scoped>
/* Add any custom styles here */

</style>
